function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "9",
  height: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.9.417v8.312l2.91-3.183a.389.389 0 01.566-.014.43.43 0 01.014.589L5.066 9.756a.78.78 0 01-1.138-.007L.61 6.12a.424.424 0 01-.11-.288c0-.11.042-.22.124-.302a.389.389 0 01.566.015L4.1 8.742V.417c0-.23.18-.417.4-.417.22 0 .4.187.4.417z",
  fill: "#E9434A",
  fillRule: "nonzero"
})));